import { createContext, useContext, useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in

  useEffect(() => {
    const token = localStorage.getItem("vp_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("vp_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password, expectedRole) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (expectedRole && data.user.role !== expectedRole) {
      throw new Error(
        expectedRole === "admin"
          ? "These are not admin credentials. Use the User login page."
          : "Admins must sign in via the Admin login page."
      );
    }
    localStorage.setItem("vp_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("vp_token");
    setUser(false);
  };

  const refresh = async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      /* noop */
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
